import { useState } from "react";
import hibretlogo from "../../assets/images/home/logo.png";


export default function Footer() {

    return (
        <footer class="text-gray-600 body-font">
            <div class="container px-5 py-24 mx-auto flex md:items-center lg:items-start md:flex-row md:flex-nowrap flex-wrap flex-col">
                <div class="w-64 flex-shrink-0 md:mx-0 mx-auto text-center md:text-left">
                    <a className="flex items-center text-black"><img src={hibretlogo} className="w-10"
                        alt="Hibret for Life" /><span className="flex flex-col text-lg font-black leading-4 text-black"><i>Hibret</i>
                            <i>for Life</i></span></a>
                    <p class="mt-2 text-sm text-gray-500 max-w-[200px]">Improving Spiritual life of the children of God. Ever Growing to his image.</p>
                </div>
                <div class="flex-grow flex flex-wrap md:pl-20 -mb-10 md:mt-0 mt-10 md:text-left text-center">
                    <div class="lg:w-1/4 md:w-1/2 w-full px-4">
                        <h2 class="title-font font-medium text-gray-900 tracking-widest text-sm mb-1">Get to know us</h2>
                        <nav class="list-none mb-10">
                            <li>
                                <a class="text-gray-600 hover:text-gray-800">About us</a>
                            </li>

                        </nav>
                    </div>
                    <div class="lg:w-1/4 md:w-1/2 w-full px-4">
                        <h2 class="title-font font-medium text-gray-900 tracking-widest text-sm mb-1">Connect</h2>
                        <nav class="list-none mb-10">
                            <li>
                                <a class="text-gray-600 hover:text-gray-800">Contact us</a>
                            </li>
                            <li>
                                <a class="text-gray-600 hover:text-gray-800">Help Center</a>
                            </li>
                            <li>
                                <a class="text-gray-600 hover:text-gray-800">Request a Speaker</a>
                            </li>
                            <li>
                                <a class="text-gray-600 hover:text-gray-800">Shop at our Store</a>
                            </li>
                        </nav>
                    </div>
                    <div class="lg:w-1/4 md:w-1/2 w-full px-4">
                        <h2 class="title-font font-medium text-gray-900 tracking-widest text-sm mb-1">Get involved</h2>
                        <nav class="list-none mb-10">
                            <li>
                                <a class="text-gray-600 hover:text-gray-800">Become a counselor</a>
                            </li>
                            <li>
                                <a class="text-gray-600 hover:text-gray-800">Pray with us</a>
                            </li>
                            <li>
                                <a class="text-gray-600 hover:text-gray-800">Partnership</a>
                            </li>
                        </nav>
                    </div>


                </div>
            </div>
            <div class="bg-slate-100">
                <div class="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row ">
                    <div className="flex items-center">
                        <p class="text-gray-500 text-sm text-center sm:text-left flex flex-col ali">© 2022 Hibret for Life <div><span>Made with ❤️ - </span>
                            <a href="https://mathiasabdissa.github.io/" rel="noopener noreferrer" class="text-gray-600 ml-1" target="_blank"> Mathias Abdissa</a></div>
                        </p>
                    </div>
                    <div class="flex flex-row sm:ml-auto sm:mt-0  mr-20 justify-items-center sm:justify-start ">
                        <a class="text-blue-600">
                            <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
                            </svg>
                        </a>
                        <a class="ml-3 text-blue-400">
                            <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
                            </svg>
                        </a>
                        <a class="ml-3 text-pink-600">
                            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
                            </svg>
                        </a>
                        <a class="ml-3 text-blue-500">
                            <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="0" class="w-5 h-5" viewBox="0 0 24 24">
                                <path stroke="none" d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"></path>
                                <circle cx="4" cy="4" r="2" stroke="none"></circle>
                            </svg>
                        </a>
                        <a class="ml-3 text-blue-500" href="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-telegram" viewBox="0 0 16 16">
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    )
}